import script from "./HistoryRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryRecord.vue?vue&type=script&setup=true&lang=js"

import "./HistoryRecord.vue?vue&type=style&index=0&id=a9b531ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9b531ac"]])

export default __exports__